import {FC} from 'react';

import NavCards from '../../ui/nav-cards/NavCards';

import {dictionaries} from '../../shared/menu.data';

import styles from './Dictionaries.module.scss';

const DictionariesPage: FC = () => {
  return (
    <div className={styles.dictionaries}>
      <div className={styles.navCards}>
        <NavCards variant="grid" menu={dictionaries} />
      </div>
    </div>
  );
};

export default DictionariesPage;
